export default __webpack_public_path__ + "static/przew_wroclaw_cover-9a6e4c38d53271924b7faa0c876836f6.jpg";